const MAP_ITEM_STREAMS = [
  {
    id: 'browsing',
    label: 'Web',
    color: 'rgb(23,121,204)',
    icon: 'web',
    description: 'Web Browsing',
  },
  {
    id: 'apps',
    label: 'App',
    color: 'rgb(91,83,223)',
    icon: 'app',
    description: 'App usage',
  },
];

export const getItemStreams = (list) => {
  return MAP_ITEM_STREAMS.filter((stream) => list && list.includes(stream.id));
};
